import { Coins } from "lucide-react";

import { Button } from "@/components/ui/button";

/**
 * <M-280> O que o chat e a auditoria mostram no lugar do erro quando o backend responde `402`:
 * a loja ficou sem créditos de IA. Ao dono da conta — o único que compra — oferece a compra;
 * a quem não é dono, diz a quem pedir.
 */
export function CreditsExhaustedNotice({
  detail,
  onBuyCredits,
}: {
  /** O `detail` do backend: quanto era preciso e quanto havia, ou a falta de assinatura. */
  detail?: string | null;
  /** Ausente quando quem vê não pode comprar. */
  onBuyCredits?: () => void;
}) {
  return (
    <div className="space-y-2 text-sm">
      <div className="flex items-center gap-2 font-medium text-foreground">
        <Coins className="h-4 w-4 text-amber-500" />
        <span>Esta loja está sem créditos de IA suficientes.</span>
      </div>
      {detail && <p className="text-xs text-muted-foreground">{detail}</p>}
      {onBuyCredits ? (
        <>
          <p className="text-muted-foreground">
            Compre um pacote para continuar agora. Os créditos comprados não expiram.
          </p>
          <Button size="sm" onClick={onBuyCredits}>
            Comprar créditos
          </Button>
        </>
      ) : (
        <p className="text-muted-foreground">
          Peça ao titular da conta para comprar mais créditos, ou aguarde a renovação do plano.
        </p>
      )}
    </div>
  );
}
